// extracted by mini-css-extract-plugin
module.exports = {"iframeText":"styles_iframeText__1o_q3","iframeHeaders":"styles_iframeHeaders__1MPL6","iframeBold":"styles_iframeBold__16XeC","iframeBoldLarge":"styles_iframeBoldLarge__2CdiL"};